import {
  GetTemplateItemMaster,
  PutTemplateItemMaster,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export type TemplateItemMasterParams = {
  templateId: number;
};

const endPoint = 'template-item';

export const getTemplateItemMaster = async (
  params: TemplateItemMasterParams,
): Promise<GetTemplateItemMaster> => {
  const queryParams = new URLSearchParams();
  queryParams.append('templateId', params.templateId.toString());
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const putTemplateItemMaster = async (
  newTemplateItem: PutTemplateItemMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newTemplateItem),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
